// extracted by mini-css-extract-plugin
export var card = "_4p-0";
export var content = "_4p-1";
export var contentLoading = "_4p-2";